document.addEventListener("DOMContentLoaded", function () {
  const customPopup = document.getElementById("custom-popup");
  const customPopupTrigger = document.getElementById("custom-popup-trigger");
  const customPopupClose = document.querySelector(".custom-popup-close");

  customPopupTrigger.addEventListener("click", function () {
    customPopup.style.display = "flex";
  });

  customPopupClose.addEventListener("click", function () {
    customPopup.style.display = "none";
  });

  window.addEventListener("click", function (event) {
    if (event.target === customPopup) {
      customPopup.style.display = "none";
    }
  });
});

